'use es6';

import { getPostSettingsErrors } from '../selectors/postSettingsErrorSelectors';
import { getPublishValidationErrors } from '../selectors/postPublishSelectors';
import isEmpty from 'hs-lodash/isEmpty';
import { validationFinished } from 'ContentEditorUI/redux/actions/appActions';
export const validate = () => (dispatch, getState) => {
  const reduxState = getState();
  const metaFormErrors = getPostSettingsErrors(reduxState);
  const publishFormErrors = getPublishValidationErrors(reduxState);
  const errors = Object.assign({}, metaFormErrors, publishFormErrors);
  const valid = isEmpty(errors);
  return dispatch(validationFinished({
    valid,
    errors
  }));
};